import * as types from '../../action-types';
import {updateCaregiverApplicationData as initialState } from "../../initialState";

const updateCaregiverApplicationData = (state=initialState, action) => {
  switch (action.type) {
    case types.APPLY_FOR_CAREGIVER_START:
      return {
        ...state,
        isLoading: true
      };
    case types.APPLY_FOR_CAREGIVER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.APPLY_FOR_CAREGIVER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.APPLY_FOR_CAREGIVER_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default updateCaregiverApplicationData;
